import React from "react";
import {Tooltip} from "antd";
import {BriefStatusToColorCompany, BriefStatus} from "./consts.jsx";

export const BriefStatusLabel = ({brief, briefStatusToColorMapper = BriefStatusToColorCompany, me = {}}) => {
    let [title, subTitle, color, backgroundColor, tooltip] = briefStatusToColorMapper[brief?.status];

    title = typeof title === "function" ? title(brief, me) : title;
    subTitle = typeof subTitle === "function" ? subTitle(brief, me) : subTitle;
    color = typeof color === "function" ? color(brief, me) : color;
    backgroundColor = typeof backgroundColor === "function" ? backgroundColor(brief, me) : backgroundColor;
    tooltip = typeof tooltip === "function" ? tooltip(brief, me) : tooltip;

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <span
                style={{
                    color,
                    backgroundColor,
                    maxWidth: "max-content",
                    padding: "0 5px",
                    fontWeight: 500
                }}>
                {tooltip ? <Tooltip title={tooltip}>{title}</Tooltip> : title}
            </span>
            {!!subTitle && <div>{subTitle}</div>}
        </div>
    );
};
